autorizationModal()

window.autorizationModal = autorizationModal

function autorizationModal() {
    

    $('.js_autorization-modal__tabs-item').on('click', function() {
        if (!$(this).hasClass('active')) {
            $('.js_autorization-modal__tabs-item').removeClass('active')
            $('.js_autorization-modal__item').removeClass('active')
            $(this).addClass('active')
            $(`.js_autorization-modal__item[data-tab="${$(this).data('tab')}"]`).addClass('active')
        }
    })

    $('.js_pass-restore__open').on('click', function() {
        $('.js_autorization-modal__main').removeClass('active')
        $('.js_pass-restore').addClass('active')
    })

    $('.js_pass-restore__close').on('click', function() {
        $('.js_pass-restore').removeClass('active')
        $('.js_autorization-modal__main').addClass('active')
    })

    $(document).on('click', '.js_autorization-modal__close, .js_autorization-modal__bg', function() {
        $('.js_autorization-modal').removeClass('active')
        $('.js_pass-restore').removeClass('active')
        $('.js_autorization-modal__main').addClass('active')
        $('body').removeAttr('style')
    })
}